// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isNullOrUndefined = (value: any) => value === null || value === undefined;

export const isEmptyArray = (arr: []) => Array.isArray(arr) && arr.length === 0;
